import { useTranslate } from "ra-core";

import { TasksListByDueDate } from "./TasksListByDueDate";
import type { TasksScope } from "./tasksScope";

export const TasksListContent = ({
  scope = "mine",
  groupByOwner = false,
}: {
  scope?: TasksScope;
  groupByOwner?: boolean;
}) => {
  const translate = useTranslate();
  return (
    <div className="flex flex-col gap-4">
      <TasksListByDueDate
        scope={scope}
        groupByOwner={groupByOwner}
        emptyPlaceholder={
          <p className="text-sm">
            {translate(
              scope === "all"
                ? "resources.tasks.empty_list_hint_all"
                : "resources.tasks.empty_list_hint",
            )}
          </p>
        }
      />
    </div>
  );
};
